<template>
    <div>
        <div v-if="settings" class="table-simple-modal">
            <b-table-simple responsive bordered>
                <b-thead>
                    <b-tr>
                        <b-th>Booking Summary</b-th>
                        <b-th>Price (RM)</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td>SPA Price</b-td>
                        <b-td v-if="selected_project.project_source_type === 'HESTIA'">{{ unit.unit_price |
                            moneyFormatter }}</b-td>
                        <b-td v-else>{{ unit.unit_price | moneyFormatter }}</b-td>
                    </b-tr>
                    <template v-if="selected_project.project_source_type === 'HESTIA'">
                        <template v-if="unit_setting.bumi_discount === 1">
                            <b-tr>
                                <b-td>Bumi Discount Percentage</b-td>
                                <b-td>{{ unit_setting.bumi_discount_percent }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>Bumi Price
                                    <span class="text-danger" v-if="unit_setting.formula_type == 'DISCOUNT'">(New SPA
                                        Price)</span>
                                </b-td>
                                <b-td>{{ bumiPrice | moneyFormatter }}</b-td>
                            </b-tr>
                        </template>
                    </template>
                    <template v-else>
                        <template v-if="unit_setting.has_bumi_discount === 1">
                            <b-tr>
                                <b-td>Bumi Discount Percentage</b-td>
                                <b-td>{{ unit_setting.bumi_discount_percent }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>Bumi Price</b-td>
                                <b-td></b-td>
                            </b-tr>
                        </template>
                    </template>

                    <b-tr>
                        <b-td>Est. Rebate Percentage</b-td>
                        <b-td>{{ unit.rebate_percent }} %</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Est. Rebate Amount</b-td>
                        <b-td>{{ unit.rebate_amount | moneyFormatter }}</b-td>
                    </b-tr>

                    <b-tr style="background: #FFF8B4">
                        <b-td>Client Nett</b-td>
                        <b-td>{{ unit.client_nett | moneyFormatter }}</b-td>
                    </b-tr>

                    <b-tr>
                        <b-td>Loan Margin</b-td>
                        <b-td>90%</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Est. Loan Amount</b-td>
                        <b-td>{{ unit.loan_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr class="font-weight-600" style="background: #FFF8B4">
                        <b-td>Client Cashback</b-td>
                        <b-td>{{ clientCashback | moneyFormatter }}</b-td>
                    </b-tr>
                </b-tbody>

                <b-thead v-if="unit_setting.other_discounts">
                    <b-tr>
                        <b-th>Renovation Package</b-th>
                        <b-th>Price (RM)</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="discount in unit_setting.other_discounts" :key="discount.id">
                        <b-td>{{ discount.name }}</b-td>
                        <b-td>{{ discount.amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr class="font-weight-600" style="background: #FFF8B4">
                        <b-td>Total Renovation Package</b-td>
                        <b-td>{{ RenovationPackageSum | moneyFormatter }}</b-td>
                    </b-tr>
                </b-tbody>
                <b-thead>
                    <b-tr>
                        <b-th>Professional Fee Summary</b-th>
                        <b-th>Price (RM)</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-if="showSPADisb">
                        <b-td>SPA Disbursement Fee</b-td>
                        <b-td>{{ unit_fees.unit_fess_sp_disbursement | moneyFormatter }}</b-td>
                    </b-tr>

                    <b-tr v-if="showSPAStampDutyFee">
                        <b-td>SPA Stamp Duty Fee</b-td>
                        <b-td>{{ unit_fees.unit_fess_sp_stamp_duty | moneyFormatter }}</b-td>
                    </b-tr>

                    <!-- <b-tr>
                        <b-td>Est. Loan Agreement</b-td>
                        <b-td>{{ unit_fees.unit_fees_loan_agreement | moneyFormatter }}</b-td>
                    </b-tr> -->

                    <b-tr v-if="showLoanStampDuty">
                        <b-td>Loan Stamp Duty</b-td>
                        <b-td>{{ unit_fees.unit_fees_loan_stamp_duty | moneyFormatter }}</b-td>
                    </b-tr>

                    <b-tr v-if="showLoanDisb">
                        <b-td>Loan Disbursement Fee</b-td>
                        <b-td>{{ unit_fees.unit_fees_loan_disbursement | moneyFormatter }}</b-td>
                    </b-tr>

                    <b-tr v-if="showMOT">
                        <b-td>Memorandum of Transfer</b-td>
                        <b-td>{{ unit_fees.unit_fees_mot | moneyFormatter }}</b-td>
                    </b-tr>

                    <b-tr v-if="showValFee">
                        <b-td>Valuation Fee</b-td>
                        <b-td>{{ unit_fees.unit_fess_valuation | moneyFormatter }}</b-td>
                    </b-tr>

                    <b-tr class="font-weight-600" style="background: #FFF8B4">
                        <b-td>Total Professional Fee Summary</b-td>
                        <b-td>{{ professionalSumm | moneyFormatter }}</b-td>
                    </b-tr>
                </b-tbody>

                <b-thead>
                    <b-tr>
                        <b-th>Miscellaneous Fee Summary</b-th>
                        <b-th>Price (RM)</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td>Booking Fee</b-td>
                        <b-td>{{ unit.fees_booking_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Deposit Fee</b-td>
                        <b-td>{{ unit.fees_deposit_amount | moneyFormatter }}</b-td>
                    </b-tr>

                    <b-tr v-if="showMaintenance">
                        <b-td>Maintenance Fee</b-td>
                        <b-td>{{ unit_fees.unit_fees_maintenance | moneyFormatter }}</b-td>
                    </b-tr>

                    <b-tr v-if="showSinkFund">
                        <b-td>Sinking Fund</b-td>
                        <b-td>{{ unit_fees.unit_fees_sinking_fund | moneyFormatter }}</b-td>
                    </b-tr>
                </b-tbody>

                <b-tfoot>
                    <b-tr class="font-weight-600" style="background: #FFF8B4">
                        <b-td>Total Miscellaneous Fee Summary</b-td>
                        <b-td>{{ totalMisc | moneyFormatter }}</b-td>
                    </b-tr>
                </b-tfoot>
            </b-table-simple>
        </div>
    </div>
</template>
<script>
import { Button, Select, Option } from 'element-ui'
import { mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'

export default {
    props: ['project', 'unit', 'unit_fees', 'unit_setting'],
    components: {
        [Button.name]: Button,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            settings: {},
        }
    },
    computed: {
        ...mapState(useProductStore, ['current_product_data', 'selected_project']),
        totalMisc() {
            const book = parseFloat(this.unit.fees_booking_amount || 0)
            const depo = parseFloat(this.unit.fees_deposit_amount || 0)
            let maintenance = 0
            let sinking = 0

            if (['1', 'Include'].includes(this.unit_setting.fees_maintenance)) {
                maintenance = parseFloat(this.unit_fees.unit_fees_maintenance || 0)
            }

            if (this.unit_setting.fees_sinking === 1 || this.unit_setting.fees_sinking_fund === 'Include') {
                sinking = parseFloat(this.unit_fees.unit_fees_sinking_fund || 0)
            }

            return book + depo + maintenance + sinking
        },

        clientCashback() {
            const loanAmount = parseFloat(this.unit.loan_amount)
            const clientNett = parseFloat(this.unit.client_nett)

            return loanAmount - clientNett
        },

        RenovationPackageSum() {
            if (!_gHlp.isEmpty(this.unit_setting.other_discounts)) {
                let totalSum = 0;
                this.unit_setting.other_discounts.forEach((oth_disc, key) => {
                    let amt = 0;
                    if (oth_disc['price_based_on_id'] == 1) {
                        amt = parseFloat(this.unit.client_nett) * (parseFloat(oth_disc['percentage']) / 100);
                        // eslint-disable-next-line vue/no-mutating-props
                        this.unit_setting.other_discounts[key]['amount'] = amt;
                    } else if (oth_disc['price_based_on_id'] == 2) {
                        amt = parseFloat(this.unit_setting.dev_net_price) * (parseFloat(oth_disc['percentage']) / 100);
                        // eslint-disable-next-line vue/no-mutating-props
                        this.unit_setting.other_discounts[key]['amount'] = amt;
                    } else if (oth_disc['price_based_on_id'] == 3) {
                        const discount = this.unit_setting.bumi_discount_percent
                        let price = 0

                        if (this.selected_project.project_source_type === 'HESTIA') {
                            price = this.unit.bumi_price
                        } else {
                            price = this.unit.unit_price
                        }

                        price =  price * (1 - discount / 100)
                        amt = price * (parseFloat(oth_disc['percentage']) / 100);
                        // eslint-disable-next-line vue/no-mutating-props
                        this.unit_setting.other_discounts[key]['amount'] = amt;
                    } else {
                        amt = parseFloat(oth_disc['amount']);
                    }
                    totalSum += amt;
                })
                console.log(totalSum)
                return totalSum;
                // return this.unit_setting.other_discounts.reduce((sum, discount) => {
                //     return sum + discount.amount; // Assuming each discount has an 'amount' property
                // }, 0);
            } else {
                return 0
            }
        },
        professionalSumm() {

            let spDisb = 0
            let spStamp = 0
            let loanStamp = 0
            let loanDisb = 0
            let mot = 0
            let val = 0

            if (this.unit_setting.fees_spa_disb === 1 || this.unit_setting.fees_spa_disbursement === 'Include') {
                spDisb = parseFloat(this.unit_fees.unit_fees_sp_disbursement || 0)
            }

            if (['1', 'Include'].includes(this.unit_setting.fees_spa_stamp_duty)) {
                spStamp = parseFloat(this.unit_fees.unit_fess_sp_stamp_duty || 0)
            }

            if (['1', 'Include'].includes(this.unit_setting.fees_loan_stamp_duty)) {
                spStamp = parseFloat(this.unit_fees.unit_fees_loan_stamp_duty || 0)
            }

            if (this.unit_setting.fees_loan_disb === 1 || this.unit_setting.fees_loan_disbursement === 'Include') {
                spDisb = parseFloat(this.unit_fees.unit_fees_loan_disbursement || 0)
            }

            if (['1', 'Include'].includes(this.unit_setting.fees_mot)) {
                mot = parseFloat(this.unit_fees.unit_fees_mot || 0)
            }

            if (this.unit_setting.fees_valuation === 1 || this.unit_setting.fees_valuation_fee === 'Include') {
                val = parseFloat(this.unit_fees.unit_fess_valuation || 0)
            }

            return spDisb + spStamp + loanStamp + loanDisb + mot + val
        },

        avgLoanMargin() {
            const projectBanks = this.selected_project.project_banks

            // Calculate the average loan margin
            const totalLoanMargin = projectBanks.reduce((sum, bank) => {
                if (this.selected_project.project_source_type === 'HESTIA') {
                    return sum + parseFloat(bank.loan_margin)
                } else {
                    return sum + parseFloat(bank.bank_loan_margin)
                }
            }, 0)

            const avgLoanMargin = (totalLoanMargin / projectBanks.length).toFixed(2)

            return avgLoanMargin
        },

        bumiPrice() {
            const discount = this.unit_setting.bumi_discount_percent
            let price

            if (this.selected_project.project_source_type === 'HESTIA') {
                return this.unit.bumi_price
            } else {
                price = this.unit.unit_price
            }

            return price * (1 - discount / 100)
        },

        showSPAStampDutyFee() {
            return (
                (this.selected_project.project_source_type === 'HESTIA' && this.unit_setting.fees_spa_stamp_duty === 1 && this.unit_setting.fees_spa_stamp_duty_status === "Paid by Client") ||
                (this.selected_project.project_source_type !== 'HESTIA' && this.unit_setting.fees_spa_stamp_duty === 'Include' && this.unit_setting.fees_spa_stamp_duty_id === 3)
            )
        },

        showSPADisb() {
            return (
                (this.selected_project.project_source_type === 'HESTIA' && this.unit_setting.fees_spa_disb === 1 && this.unit_setting.fees_spa_disb_status === "Paid by Client") ||
                (this.selected_project.project_source_type !== 'HESTIA' && this.unit_setting.fees_spa_disbursement === 'Include' && this.unit_setting.fees_spa_disbursement_id === 3)
            )
        },

        showLoanStampDuty() {
            return (
                (this.selected_project.project_source_type === 'HESTIA' && this.unit_setting.fees_loan_stamp_duty === 1 && this.unit_setting.fees_loan_stamp_duty_status === "Paid by Client") ||
                (this.selected_project.project_source_type !== 'HESTIA' && this.unit_setting.fees_loan_stamp_duty === 'Include' && this.unit_setting.fees_loan_stamp_duty_id === 3)
            )
        },

        showLoanDisb() {
            return (
                (this.selected_project.project_source_type === 'HESTIA' && this.unit_setting.fees_loan_disb === 1 && this.unit_setting.fees_loan_disb_status === "Paid by Client") ||
                (this.selected_project.project_source_type !== 'HESTIA' && this.unit_setting.fees_loan_disbursement === 'Include' && this.unit_setting.fees_loan_disbursement_id === 3)
            )
        },

        showMOT() {
            return (
                (this.selected_project.project_source_type === 'HESTIA' && this.unit_setting.fees_mot === 1 && this.unit_setting.fees_mot_status === "Paid by Client") ||
                (this.selected_project.project_source_type !== 'HESTIA' && this.unit_setting.fees_mot === 'Include' && this.unit_setting.fees_mot_id === 3)
            )
        },

        showValFee() {
            return (
                (this.selected_project.project_source_type === 'HESTIA' && this.unit_setting.fees_valuation === 1 && this.unit_setting.fees_valuation_status === "Paid by Client") ||
                (this.selected_project.project_source_type !== 'HESTIA' && this.unit_setting.fees_valuation_fee === 'Include' && this.unit_setting.fees_valuation_fee_id === 3)
            )
        },

        showMaintenance() {
            return (
                (this.selected_project.project_source_type === 'HESTIA' && this.unit_setting.fees_maintenance === 1) ||
                (this.selected_project.project_source_type !== 'HESTIA' && this.unit_setting.fees_maintenance === 'Include')
            )
        },

        showSinkFund() {
            return (
                (this.selected_project.project_source_type === 'HESTIA' && this.unit_setting.fees_sinking === 1) ||
                (this.selected_project.project_source_type !== 'HESTIA' && this.unit_setting.fees_sinking_fund === 'Include')
            )
        },
    },
    watch: {
        selected_project: {
            handler(newVal) {
                if (newVal && newVal.project_setting) {
                    this.settings = newVal.project_setting
                } else {
                    this.settings = null
                }
            },
            immediate: true
        },
    },

}
</script>